import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, map, catchError, of } from 'rxjs';
import { FabricDataService } from '../fabric-data.service';
import { getPermissionForRoute } from '../models/dashboard.config';

/**
 * Permission guard that checks if the user has the required permission for a specific dashboard
 */
export const PermissionGuard = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const fabricDataService = inject(FabricDataService);
  const router = inject(Router);

  const requiredPermission = getPermissionForRoute(route.routeConfig?.path || '');

  if (!requiredPermission) {
    console.warn(`No permission mapping found for route: ${route.routeConfig?.path}`);
    // If no permission mapping is found, deny access
    return of(router.createUrlTree(['/not-found']));
  }

  return fabricDataService.getDashboardPermissions().pipe(
    map(permissions => {
      console.log('User permissions:', permissions);
      console.log('Required permission:', requiredPermission);
      
      if (permissions.includes(requiredPermission)) {
        console.log(`Permission granted for ${requiredPermission}`);
        return true;
      } else {
        console.log(`Permission denied for ${requiredPermission}`);
        // Redirect to not-found page if permission is not found
        return router.createUrlTree(['/not-found']);
      }
    }),
    catchError(error => {
      console.error('Error checking permissions:', error);
      // On error, redirect to not-found page
      return of(router.createUrlTree(['/not-found']));
    })
  );
};
